import React from "react";
import { format } from "date-fns";
import { ICellRendererParams } from "@ag-grid-community/core";

import { TwoLineGridCell } from "../../../TransactionsDataGrid/renderers";
import { TransferListItem } from "../../../../types";

interface Props extends ICellRendererParams {
  data: TransferListItem;
}

const DateRenderer = ({ data }: Props) => {
  if (!data.completedDate) {
    return <div />;
  }

  const firstLine = format(new Date(data.completedDate), "MMM d, yyyy");
  const secondLine = format(new Date(data.completedDate), "h:mm a");

  return (
    <TwoLineGridCell firstLineData={firstLine} secondLineData={secondLine} />
  );
};

export default DateRenderer;
